import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[580px] md:h-[720px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20minimalist%20ecommerce%20product%20photography%20studio%20setup%20with%20assorted%20fashion%20items%20including%20white%20sneakers%2C%20beige%20hoodie%2C%20and%20canvas%20tote%20bag%20arranged%20on%20light%20oak%20wooden%20surface%2C%20soft%20diffused%20window%20lighting%20casting%20gentle%20shadows%2C%20cream%20and%20warm%20sand%20neutral%20tones%2C%20clean%20professional%20aesthetic%20with%20potted%20succulents%20in%20ceramic%20planters%2C%20editorial%20catalog%20style%20composition%20with%20copy%20space%2C%20serene%20and%20inviting%20atmosphere%20for%20online%20shopping%20guide%20website&width=1920&height=1080&seq=kakobuy-hero-v8&orientation=landscape"
          alt="Kakobuy Spreadsheet - stylowe produkty z Chin na jasnym tle"
          title="Kakobuy Spreadsheet - produkty modowe"
          className="w-full h-full object-cover object-center"
        />
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <p className="text-sm md:text-base font-medium text-background-50/80 tracking-widest uppercase mb-4">
          Twój przewodnik po zakupach z Chin
        </p>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
          Kakobuy <span className="text-primary-300">Spreadsheet</span>
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          Kompletny arkusz kalkulacyjny z najlepszymi produktami z Chin. Buty, bluzy, koszulki, akcesoria — wszystko w jednym miejscu. Oszczędzaj czas i pieniądze dzięki sprawdzonym linkom.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
          >
            Kakobuy Spreadsheet
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-sm"></i>
            </span>
          </a>

          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 text-sm font-semibold bg-background-50/15 backdrop-blur-sm text-background-50 hover:bg-background-50/25 border border-background-50/30 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shopping-bag-line text-sm"></i>
            </span>
          </a>
        </div>

        {/* Scroll indicator */}
        <div className="mt-12 hidden md:flex flex-col items-center gap-2 animate-bounce">
          <span className="text-xs text-background-50/50 tracking-wider">Przewiń w dół</span>
          <span className="w-5 h-5 flex items-center justify-center text-background-50/40">
            <i className="ri-arrow-down-s-line text-lg"></i>
          </span>
        </div>
      </div>
    </section>
  );
}